import { AxiosService } from '../../axios/axios.service.ts';
import { tAxiosCustomConfig } from '../../axios/axios.types.ts';
import { tGetNotificationsResponse } from './Notification.types.ts';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from 'src/lib/logging';

export async function getNotifications(wid: string, uid: string) {
  try {
    const config: tAxiosCustomConfig = {
      isLegacy: true,
      headers: undefined,
    };
    const response = await AxiosService.get<tGetNotificationsResponse>(
      `notifications/notifications?workspace_id=${wid}&user_id=${uid}`,
      config,
    );
    return Promise.resolve(response.data);
  } catch (error) {
    LLog.error(
      {
        component: LOG_COMPONENTS.NOTIFICATION,
        method: 'Notifications.service',
        operation: LOG_OPERATIONS.ERROR,
      },
      'Error al obtener el estado de los servicios',
      error as unknown as Error,
    );
    return Promise.reject(error);
  }
}

export async function dismissNotification(notificationId: string) {
  try {
    const config: tAxiosCustomConfig = {
      isLegacy: true,
      headers: undefined,
    };

    const response = await AxiosService.post(
      `notifications/notifications/${notificationId}/dismiss`,
      {},
      config,
    );
    return Promise.resolve(response);
  } catch (error) {
    LLog.error(
      {
        component: LOG_COMPONENTS.NOTIFICATION,
        method: 'Notifications.service',
        operation: LOG_OPERATIONS.ERROR,
      },
      'Error al descartar notificación',
      error as unknown as Error,
    );
    return Promise.resolve(error);
  }
}
